import React, { Fragment } from "react";
import { createUseStyles } from "react-jss";
import { Form, FormStateStatus, OpacityOverlay } from "../..";
import { FormArray, FormConsumer } from "../../Form";
import { FormGridInput } from "../../forms/formGrid/FormGridInput";
import { TableBulkAction } from "./TableBulkAction";
import { V2TableBody, V2TableWrapper } from "./Table";
import { V2TableCell } from "./TableCell";
import { TableDrawer } from "./TableDrawer";
import { V2TableHeader } from "./TableHeader";
import { V2TableRowComponent } from "./TableRow";
import { getCellDataId, getCellDataTestId } from "../tableUtils";
import { getItemNodeFormatting, getBoolValueFromRow } from "./utilsV2Table";
import { TableRowAction } from "./TableRowAction";
import { TableLoading } from "./TableSkeleton";
import { getInlineFeedback } from "./InlineFeedback";
import { useTableContext } from "../../hooks/useTableContext";
export function V2TableForm(props) {
    const { form } = props;
    const showBulkAction = props?.headings?.some((heading) => heading.formComponent?.bulkAction);
    if (!form)
        return null;
    if (form.childForm) {
        return (React.createElement(Form, { values: form?.values ?? {}, element: "div" },
            React.createElement(V2TableWrapper, { ...props },
                React.createElement(V2TableHeader, { ...props }),
                form.viewState === "edit" &&
                    form.type !== "checkbox" &&
                    showBulkAction ? (React.createElement(Fragment, null,
                    React.createElement(TableBulkAction, { headings: props?.headings, form: form }),
                    React.createElement(V2TableFormBody, { ...props }))) : (React.createElement(V2TableFormBody, { ...props })))));
    }
    else {
        return (React.createElement(Form, { values: form?.values ?? {} },
            React.createElement(FormStateStatus, { saveState: form.saveState, messages: form.messages }),
            React.createElement(OpacityOverlay, { on: form.saveState === "saving" },
                React.createElement(V2TableWrapper, { ...props },
                    React.createElement(V2TableHeader, { ...props }),
                    form.viewState === "edit" &&
                        form.type !== "checkbox" &&
                        showBulkAction ? (React.createElement(Fragment, null,
                        React.createElement(TableBulkAction, { headings: props?.headings, form: form, dataId: props?.dataId, dataTestId: props?.dataTestId }),
                        React.createElement(V2TableFormBody, { ...props }))) : form.type === "checkbox" ? (React.createElement(V2TableBody, { ...props })) : (React.createElement(V2TableFormBody, { ...props }))))));
    }
}
export function V2TableFormBody(props) {
    const { gridClassName } = useTableContext();
    const classes = useTableFormClasses();
    const { form } = props;
    const { values, name } = form;
    const tableHasData = values[name].length > 0;
    if (!tableHasData)
        return React.createElement("div", null, "empty");
    if (props?.loading) {
        return React.createElement(TableLoading, { ...props });
    }
    return (React.createElement(FormArray, { name: name },
        React.createElement(FormConsumer, null, ({ values, errors, arrayIndex }) => {
            return (React.createElement(V2TableRowComponent, { item: values, rowIndex: arrayIndex, ...props, gridClassName: gridClassName },
                props.headings.map((heading, cellIndex) => {
                    const cellDataId = getCellDataId(arrayIndex, props?.dataId);
                    const cellDataTestId = getCellDataTestId(arrayIndex, props?.dataTestId);
                    let overflowTooltipContent = undefined;
                    if (heading.tipFormatter) {
                        overflowTooltipContent = heading.tipFormatter(values);
                    }
                    let helperTooltipContent = undefined;
                    if (heading.formComponent?.helperTooltip) {
                        helperTooltipContent =
                            heading.formComponent?.helperTooltip(values);
                    }
                    return (React.createElement(V2TableCell, { colIndex: cellIndex + 1, ...props, heading: heading, key: `${arrayIndex}${cellIndex}`, className: classes.cellForm, dataId: cellDataId && `${cellDataId}-${cellIndex}`, dataTestId: cellDataTestId && `${cellDataTestId}-${cellIndex}`, tooltipContent: overflowTooltipContent, inlineFeedback: getInlineFeedback(props?.feedback, props?.rowKey, values, heading) }, heading.formComponent &&
                        !getBoolValueFromRow(values, heading.formComponent?.hidden) ? (React.createElement(FormGridInput, { column: heading.formComponent, labelHidden: true, viewState: form?.viewState, rowId: arrayIndex, disabled: getBoolValueFromRow(values, heading.formComponent?.disabled), dataId: cellDataId && `${cellDataId}-${cellIndex}`, dataTestId: cellDataTestId && `${cellDataTestId}-${cellIndex}`, helperTooltip: helperTooltipContent })) : (getItemNodeFormatting(heading, values))));
                }),
                props.dropdown && props.form?.viewState !== "edit" && (React.createElement(TableRowAction, { item: values, rowIndex: arrayIndex, ...props })),
                props.drawer && (React.createElement(TableDrawer, { item: values, rowIndex: arrayIndex, ...props }))));
        })));
}
export const useTableFormClasses = () => {
    const useStyles = createUseStyles({
        cellForm: {
            "& .radio-buttons": {
                marginBottom: 2,
            },
            "& .form-group": {
                marginBottom: 0,
                "& .checkbox": {
                    marginTop: 0,
                    marginBottom: 0,
                    "& label": {
                        paddingTop: 4,
                        paddingBottom: 4,
                        marginBottom: 0,
                    },
                },
                "& .help-block": {
                    marginTop: 0,
                    marginBottom: 0,
                },
                "& .form-control-static": {
                    paddingTop: 5,
                    minHeight: 30,
                },
                "& .form-control": {
                    margin: "4px 0",
                },
            },
        },
    });
    return useStyles();
};
